import { pdfjs } from "react-pdf";

import type { EditablePage } from "../types";

export const getPdfPages = async (
  initialPdfBlobs: {
    invoiceId: string;
    fileName: string;
    pdfUrl: string;
    thumbnailUrls?: string[];
  }[],
) => {
  const allPages: EditablePage[] = [];

  for (let pdfIndex = 0; pdfIndex < initialPdfBlobs.length; pdfIndex++) {
    const pdfUrl = initialPdfBlobs[pdfIndex].pdfUrl;

    let loadingTask;
    if (pdfUrl.startsWith("blob:")) {
      const response = await fetch(pdfUrl);
      const arrayBuffer = await response.arrayBuffer();
      loadingTask = pdfjs.getDocument({
        data: arrayBuffer,
      });
    } else {
      loadingTask = pdfjs.getDocument({
        url: pdfUrl,
        withCredentials: false,
      });
    }

    const pdf = await loadingTask.promise;
    const pageCount = pdf.numPages;

    pdf.destroy();

    for (let pageIndex = 0; pageIndex < pageCount; pageIndex++) {
      const thumbnails = initialPdfBlobs[pdfIndex].thumbnailUrls ?? [];
      allPages.push({
        id: `${initialPdfBlobs[pdfIndex].invoiceId}-${pageIndex}-${Date.now()}`,
        sourcePdfUrl: initialPdfBlobs[pdfIndex].pdfUrl,
        sourcePageIndex: pageIndex,
        sourceInvoiceId: initialPdfBlobs[pdfIndex].invoiceId,
        sourceInvoiceFileName: initialPdfBlobs[pdfIndex].fileName,
        currentDisplayIndex: allPages.length,
        thumbnailUrl: thumbnails[pageIndex],
      });
    }
  }

  return allPages;
};
